import { z } from 'zod';
/** Narrow Relationships-owned identity verification capability for import consumers. */
export const relationshipsImportResolutionCapability = 'relationships.import-resolution.v1';
export const relationshipsImportResolutionEntityTypeSchema = z.enum([
    'organization',
    'contact',
]);
const timestamp = z.string().datetime({ offset: true });
const uuid = z.string().uuid();
const sha256 = z.string().regex(/^[a-f0-9]{64}$/);
/** Durable proof that one imported Relationships identity is tenant-bound and target-backed. */
export const relationshipsImportResolutionSchema = z.strictObject({
    capability: z.literal(relationshipsImportResolutionCapability),
    entityType: relationshipsImportResolutionEntityTypeSchema,
    sourceId: z.string().trim().min(1).max(240),
    targetId: uuid,
    sourceSha256: sha256,
    sourceUpdatedAt: timestamp,
    runId: uuid,
    targetSha256: sha256,
});
//# sourceMappingURL=relationships-import-resolution.contract.js.map